// CLP client-side helpers — month axis + formatting (mirrors backend engine).

const MONTHS = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function parseYm(s) {
    if (!s || typeof s !== "string") return null;
    const [y, m] = s.split("-");
    const yy = parseInt(y, 10), mm = parseInt(m, 10);
    if (Number.isNaN(yy) || Number.isNaN(mm)) return null;
    return [yy, mm];
}

export function ymKey(y, m) {
    return `${String(y).padStart(4, "0")}-${String(m).padStart(2, "0")}`;
}

export function addMonths(y, m, n) {
    const idx = y * 12 + (m - 1) + n;
    return [Math.floor(idx / 12), (idx % 12) + 1];
}

export function monthsBetween(a, b) {
    return (b[0] - a[0]) * 12 + (b[1] - a[1]);
}

export function monthLabel(key) {
    const ym = parseYm(key);
    if (!ym) return key || "—";
    return `${MONTHS[ym[1]]} ${ym[0]}`;
}

// Build the programme month axis from the stage list (earliest start -> latest end).
export function buildAxis(stages) {
    const dated = (stages || []).filter((s) => parseYm(s.start_month) && parseYm(s.end_month));
    if (!dated.length) return [];
    const starts = dated.map((s) => parseYm(s.start_month));
    const ends = dated.map((s) => parseYm(s.end_month));
    const lo = starts.reduce((a, b) => (a[0] * 12 + a[1] <= b[0] * 12 + b[1] ? a : b));
    const hi = ends.reduce((a, b) => (a[0] * 12 + a[1] >= b[0] * 12 + b[1] ? a : b));
    const n = monthsBetween(lo, hi) + 1;
    const out = [];
    for (let i = 0; i < Math.max(n, 1); i++) {
        const [yy, mm] = addMonths(lo[0], lo[1], i);
        out.push(ymKey(yy, mm));
    }
    return out;
}

export function inWindow(stage, key) {
    const a = parseYm(stage.start_month), b = parseYm(stage.end_month), k = parseYm(key);
    if (!a || !b || !k) return false;
    const ki = k[0] * 12 + k[1];
    return a[0] * 12 + a[1] <= ki && ki <= b[0] * 12 + b[1];
}

export function fmtNum(v, dp = 1) {
    if (v === null || v === undefined || v === "") return "—";
    const f = Number(v);
    if (Number.isNaN(f)) return String(v);
    if (Math.abs(f - Math.round(f)) < 1e-9) return String(Math.round(f));
    return f.toFixed(dp);
}
